import { c as _c } from "react/compiler-runtime";
import type { ReviewCreditCardsPage } from '@cc-shopping/contracts/credit-cards-page/reviews/schema/types';
import type { BoxProps } from '@mui/material';
import { NerdWalletRating } from 'src/features/product-card/NerdWalletRating';
type AlternatePickRatingProps = BoxProps & {
  ctaAnalytics: NonNullable<ReviewCreditCardsPage['alternatePicks'][number]['marketplaceEntity']>['ctaAnalytics'];
  reviewLink: string;
  starRating: number;
  starRatingTooltip?: string;
};
export default function AlternatePickRating(t0) {
  const $ = _c(14);
  let containerProps;
  let ctaAnalytics;
  let reviewLink;
  let starRating;
  let starRatingTooltip;
  if ($[0] !== t0) {
    ({
      ctaAnalytics,
      reviewLink,
      starRating,
      starRatingTooltip,
      ...containerProps
    } = t0);
    $[0] = t0;
    $[1] = containerProps;
    $[2] = ctaAnalytics;
    $[3] = reviewLink;
    $[4] = starRating;
    $[5] = starRatingTooltip;
  } else {
    containerProps = $[1];
    ctaAnalytics = $[2];
    reviewLink = $[3];
    starRating = $[4];
    starRatingTooltip = $[5];
  }
  let t1;
  if ($[6] !== containerProps) {
    t1 = {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      "data-testid": "alternate-pick-rating",
      ...containerProps
    };
    $[6] = containerProps;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== ctaAnalytics || $[9] !== reviewLink || $[10] !== starRating || $[11] !== starRatingTooltip || $[12] !== t1) {
    t2 = <NerdWalletRating variant="reviews" ctaAnalytics={ctaAnalytics} reviewLink={reviewLink} starRating={starRating} starRatingTooltip={starRatingTooltip} segmentActionSection="alt_pick" containerProps={t1} isMonetizing={false} />;
    $[8] = ctaAnalytics;
    $[9] = reviewLink;
    $[10] = starRating;
    $[11] = starRatingTooltip;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}